import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { visuallyFormatPhoneNumber } from '../../../helpers/general';
import { modifyObject } from '../../../helpers/modifyObject';
import Close from '../../common/ui/Close';
import Validator from '../../common/forms/Validator';
import ErrorMessage from '../../common/forms/ErrorMessage';
import SwitchRow from '../../common/forms/SwitchRow';
import FormActionButtons from '../../common/forms/FormActionButtons';
import ChangeUserPasswordModal from '../../ChangeUserPasswordModal';

export default class EditAdmin extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleEditModal: PropTypes.func.isRequired,
    handleChangePassword: PropTypes.func.isRequired
  };

  validationRules = {
    first_name: { required: true },
    last_name: { required: true },
    phone: { required: true }
  };

  constructor (props) {
    super(props);

    this.state = {
      ...props.user
    };
  }

  switch = () => this.setState({ is_active: !this.state.is_active });

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleChangePhone = event => {
    const { value } = event.target;
    this.setState({
      phone: visuallyFormatPhoneNumber(value)
    });
  };

  editAdminSubmit = event => {
    event.preventDefault();
    if (this.validate(this.validationRules)) {
      const { first_name, last_name, phone, is_active } = this.state;
      this.props.handleSubmit(event, modifyObject({ first_name, last_name, phone, is_active }));
    }
  };

  setUser = user => this.setState({ ...user });

  componentDidUpdate (prevProps) {
    if (this.props.user.id !== prevProps.user.id) {
      this.setUser(this.props.user);
    }
  }

  render () {
    const { isOpen, toggleEditModal, handleChangePassword } = this.props;
    const errors = this.validationErrors;

    return (
      <Modal isOpen={isOpen} toggle={toggleEditModal}>
        <div className='modal-header'>
          <div className='modal-title'>Edit Admin</div>
          <Close onClick={toggleEditModal} />
        </div>
        <ModalBody>
          <div>
            <form onSubmit={this.editAdminSubmit}>
              <div className='form-group'>
                <label htmlFor='edit_first_name'>First Name</label>
                <input className='input' id='edit_first_name'
                  name='first_name'
                  value={this.state.first_name || ''}
                  onChange={this.handleChange}
                />
                <ErrorMessage errorText={errors.first_name} />
              </div>
              <div className='form-group'>
                <label htmlFor='edit_last_name'>Last Name</label>
                <input className='input' id='edit_last_name'
                  name='last_name'
                  value={this.state.last_name || ''}
                  onChange={this.handleChange} />
                <ErrorMessage errorText={errors.last_name} />
              </div>
              <div className='form-group'>
                <label htmlFor='edit_phone'>Phone Number</label>
                <input className='input' id='edit_phone'
                  name='phone' type='tel'
                  value={this.state.phone || ''}
                  onChange={this.handleChangePhone} />
                <ErrorMessage errorText={errors.phone} />
              </div>
              <div className='form-group'>
                <ChangeUserPasswordModal handleChangePassword={handleChangePassword} />
              </div>
              <div className='form-group'>
                <SwitchRow checked={!this.state.is_active} onChange={this.switch} label='Disable Account' />
              </div>

              <FormActionButtons onClickCancel={toggleEditModal} submitTitle='Done' />
            </form>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/admins/EditAdmin.js